import React from 'react';
import { localise } from '../../../../../services/lang/lang';
import { Alert } from '../../../../modules/Alert/Alert';
import { useTokens } from '../../../../../context/TokenProvider';
const InspectionDetailDataPopulationAlert = () => {
    const tokens = useTokens();
    return (React.createElement(Alert, { "data-testid": "inspection-detail-content__alert", status: "info", mb: tokens.Spacing04, mt: "36px", icon: true, title: localise('INSPECTION_DETAILS') }, localise('INSPECTION_DETAIL_DATA_POPULATED')));
};
export default InspectionDetailDataPopulationAlert;
